import $ from 'jquery';
import { gsap } from 'gsap';
import Function from './_Function.js';

export default class OnResize {

  constructor() {}

  setOpScale() {
    let perW = Function.getOpPer();
    // let perH = $(window).height() / beseH;
    // let per = (perW > perH)? perH : perW;
    // console.log(perW,perH);
    gsap.set('.op__container', {
      scale: perW,
    });
  }

}

